import React from "react";
import ProjectList from "../components/Apps/ASPECFatigueAnalysis/projectList/ProjectList";
import { CssBaseline } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AspecFatigueAnalysis = () => {
  const navigate = useNavigate();

  return (
    <div>
      <ProjectList navigate={navigate} />
    </div>
  );
};

export default AspecFatigueAnalysis;
